<template>
    <div class="h-100">
        <template v-if="isMobile">
            <div class="row p-0" style="margin: 0 0 20px 0">
                <div :class="isMobile ? 'col-12 text-center' : 'col-auto p-0'">
                    <div class="d-inline-block page-title-box-spacing">
                        <div
                            class="d-flex align-items-center topbar-right-spacing name-header"
                            :class="isMobile && 'm-0'"
                        >
                            <div>
                                {{
                                    editView
                                        ? 'Խմբագրել մրցույթ'
                                        : 'Ավելացնել մրցույթ'
                                }}
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="isMobile ? 'col-12 text-center' : 'col-auto p-0'">
                    <div class="row justify-content-center">
                        <div
                            v-if="!editView"
                            class="col-auto p-0 padding-l-10 padding-r-10"
                        >
                            <button
                                @click="
                                    $router.push('/timeless-tenders/buy/list')
                                "
                                class="btn btn-big btn-outline-secondary"
                            >
                                <span>Դադարեցնել</span>
                            </button>
                        </div>
                        <div
                            class="col-auto p-0 padding-l-10 padding-r-10 second-button"
                        >
                            <button
                                @click="confirm"
                                :disabled="loading"
                                class="btn btn-big btn-primary"
                            >
                                <span>{{
                                    editView ? 'Խմբագրել' : 'Հաստատել'
                                }}</span>
                                <span
                                    v-if="loading"
                                    class="ml-2 spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="page-title-box-spacing">
                <div class="row justify-content-between align-items-center">
                    <div class="col-auto">
                        <div class="d-inline-block">
                            <div
                                class="d-flex align-items-center topbar-right-spacing name-header"
                            >
                                <div>
                                    {{
                                        editView
                                            ? 'Խմբագրել Անժամկետ մրցույթ'
                                            : 'Ավելացնել Անժամկետ մրցույթ'
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="row">
                            <div v-if="!editView" class="col-auto">
                                <button
                                    @click="
                                        $router.push(
                                            '/timeless-tenders/buy/list'
                                        )
                                    "
                                    class="btn btn-outline-secondary"
                                >
                                    <span>Դադարեցնել</span>
                                </button>
                            </div>
                            <div class="col-auto pl-md-0">
                                <button
                                    @click="confirm"
                                    :disabled="loading"
                                    class="btn btn-primary"
                                >
                                    <span>{{
                                        editView ? 'Խմբագրել' : 'Հաստատել'
                                    }}</span>
                                    <span
                                        v-if="loading"
                                        class="ml-2 spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div class="row p-0 mx-0 content-height">
            <delete-modal confirmBtnText="Այո" declineBtnText="Ոչ" />
            <div class="col-md-3 p-0">
                <div class="card mb-0 h-100">
                    <div class="card-header">
                        Ավելացնել տենդերի կատեգորիաները
                    </div>
                    <div class="card-body p-0">
                        <lot-list
                            @deleteLot="openDeleteModal"
                            @addLots="addLots"
                            @addCategory="addCategory"
                            @deleteLots="deleteLots"
                            :lots="rows"
                            :category="selectedCategory"
                            :isFromOutside="
                                rows[0]
                                    ? Boolean(rows[0].is_from_outside)
                                    : false
                            "
                            :insert-lot-from-outside="false"
                            :selected-lot="selectedCpv"
                        />
                    </div>
                </div>
            </div>
            <div
                v-if="!editView || tenderData.name"
                class="col-md-9 padding-l-20 px-0"
            >
                <tender-form
                    ref="tenderForm"
                    :tenderData="tenderData"
                    :tenderCode="tenderCode"
                    :editView="editView"
                    class="bg-white"
                    :rows="rows"
                    :category="selectedCategory"
                />
            </div>
        </div>
        <add-cpv-modal :isMonoSelect="true" />
        <add-category-modal />
    </div>
</template>

<script>
import TenderForm from './partials/TenderForm.vue'
import isMobile from '@/mixins/isMobileView'
import LotList from './partials/LotList.vue'
import AddCpvModal from '@/views/private/organizator/addTender/modals/AddCpvModal.vue'
import AddCategoryModal from '../modals/AddCategoryModal.vue'

export default {
    name: 'CreateTimelessTenderContainer',
    mixins: [isMobile],
    components: {
        AddCategoryModal,
        AddCpvModal,
        LotList,
        TenderForm,
        DeleteModal: () => import('@/components/helpers/DeleteModal.vue'),
    },
    computed: {},
    watch: {},
    data() {
        return {
            loading: false,
            editView: false,
            selectedCpv: {},
            selectedCategory: {},
            tenderData: false,
            tenderCode: false,
            rows: [],
        }
    },
    mounted() {
        if (this.$route.params.tenderId) {
            this.editView = true
            this.$client
                .get(`timeless-tenders/${this.$route.params.tenderId}`)
                .then(({ data: { data } }) => {
                    this.tenderData = data
                    this.rows = [data.cpv]
                    if (data.category) {
                        this.selectedCategory = {
                            value: data.category
                        }

                    }
                })
                .catch((value) => {
                    this.$router.push('/organizator/tenders/list')
                })
        }
    },
    methods: {
        async confirm() {
          this.loading = true
          try {
            await this.$refs.tenderForm.confirm()
          } catch(error) {
            this.loading = false
          } finally {
            this.loading = false
          }
        },
        consoleLog(e) {
            console.log(e)
        },
        addLots(lots) {
            const code = lots[0].code
            this.tenderCode = `iT${code}`

            this.$client
                .get(`timeless-tenders/checkTenderCode/${this.tenderCode}`)
                .then(({ data }) => {
                    console.log('data', data)
                    if (data.tendersWithSameCode) {
                        this.tenderCode = `iT${code}/${data.tendersWithSameCode}`
                    }
                })

            this.rows = [...lots]
        },
        addCategory(category) {
            console.log('category', category, 'category.name', category.name)
            this.selectedCategory = category
        },
        deleteLots(lots) {
            lots.forEach((lot) => {
                const index = this.rows.indexOf(lot)
                if (index > -1) {
                    this.rows.splice(index, 1)
                }
            })
        },
        openDeleteModal({ lotId, nextLotIndex }) {
            this.$modal.show('delete-modal', {
                msg: 'Հեռացնե՞լ գնման առարկան',
                callback: async () => {
                    this.rows.splice(nextLotIndex - 1, 1)
                    this.$modal.hide('delete-modal')
                },
            })
        },
    },
}
</script>
<style>
.content-min-height,
.content-min-height > .row,
.content-min-height > .row > [class*='col-'] {
    min-height: calc(100vh - 110px);
}
</style>
<style scoped>
.btn {
    padding-bottom: 7px;
    padding-top: 5px;
    height: 36px;
}
.scroll-bar-slim {
    background: rgba(162, 177, 208, 0.13);
    width: 7px;
    position: absolute;
    top: 15px;
    opacity: 1;
    display: block;
    border-radius: 7px;
    z-index: 99;
    right: 1px;
    height: 90.9091px;
}
.component-fade-enter-active,
.component-fade-leave-active {
    transition: opacity 0.2s ease;
}
.component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
@media only screen and (max-width: 700px) {
    .mob {
        display: flex;
        flex-direction: column;
    }
    .mob_block {
        padding: 0;
        max-width: 100%;
    }
}
</style>
